(function () {
  // Live-update the "Colour: X" label on hover so a shopper can read a name
  // without navigating away. Reverts on mouse-out.
  var root = document.querySelector('[data-sibling-swatches]');
  if (!root) return;

  var label = root.querySelector('.sibling-swatches__current');
  if (!label) return;

  var original = label.textContent;

  root.querySelectorAll('.sibling-swatches__link').forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      label.textContent = link.dataset.colourName;
    });
    link.addEventListener('mouseleave', function () {
      label.textContent = original;
    });
  });
})();
